import { COLUMN_NAME, COLUMN_READERS_COUNT, COLUMN_SITE, COLUMN_TYPE } from "../../constants/column-types";
import { FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const LockPresetColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE,
    },
    {
        heading: "Locks",
        accessor: "devices",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "locks",
        columnId: COLUMN_READERS_COUNT,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 3,
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        columnId: COLUMN_SITE,
        settingDataName: "site"
    }
];

export default LockPresetColumns;
